module.exports = __webpack_public_path__ + "static/media/sf.a3b9549e.png";